import { useCallback, useEffect, useState } from "react";
import { downloadImage } from "../../../utils/upload-image";
import { getSubdomain } from "../../../utils/utils";
import { getCastellerDisplayName } from "../../../utils/castellerName";

const COLLA = getSubdomain();

export function ProfilePic({ user, width, height, rounded=true, touchToEnlarge=false }) {
    const [showPopup, setShowPopup] = useState(false);
    const [profilePics, setProfilePics] = useState({});

    // Load static images only once
    const loadingGif = 'https://retchhh.files.wordpress.com/2015/03/loading1.gif';
    const placeholderImage = 'https://forum.truckersmp.com/uploads/monthly_2019_09/imported-photo-12263.thumb.png.0a337947bd0458971e73616909a5b1f8.png';

    const getFromCache = useCallback(() => {
        const cachedImage = localStorage.getItem(user);
        if (cachedImage && cachedImage !== 'null') {
            return cachedImage;
        }
        return null;
    }, [user]);
    
    const saveToCache = useCallback((base64Image) => {
        if (base64Image && base64Image !== 'null') {
            try {
                localStorage.setItem(user, base64Image);
            } catch (e) {
                console.log('Error saving profile pic to cache', e);
            }
        }
    }, [user]);
    
    const downloadProfilePic = useCallback(async () => {
        try {
            // let base64 = getFromCache();
            downloadImage(user, COLLA).then(downloadedBase64 => {
                if (!downloadedBase64) {
                    setProfilePics(prev => ({ ...prev, [user]: false }));
                } else {
                    setProfilePics(prev => ({ ...prev, [user]: downloadedBase64 }));
                }
            });
            // saveToCache(base64);
        } catch (e) {
            setProfilePics({ ...profilePics, [user]: null });
        }
    }, [user, getFromCache, saveToCache]);

    useEffect(() => {
        // Get from server or cache
        downloadProfilePic();
    }, [downloadProfilePic]);

    useEffect(() => {
        setProfilePics({});
    }, [user])

    const profile_pic_style = {
        width: width,
        height: height,
        borderRadius: rounded ? '100%' : 10,
        objectFit: 'cover',
        objectPosition: 'center',
    };

    return (
        <div
            className="author-photo"
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                cursor: touchToEnlarge ? 'pointer' : 'default'
            }}
        >
            <img
                src={
                    profilePics[user] === undefined ? loadingGif :
                    profilePics[user] === null ? loadingGif :
                    !profilePics[user] ? placeholderImage :
                    profilePics[user]
                }
                style={{
                    ...profile_pic_style,
                    backgroundColor: profilePics[user] ? undefined : '#ccc',
                }}
                // onError={downloadProfilePic}
                onClick={() => touchToEnlarge && setShowPopup(true)}
            />
            {showPopup && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 9999,
                    cursor: 'pointer',
                }}
                onClick={() => setShowPopup(false)}
                >
                    <img
                        src={profilePics[user] ? profilePics[user] : placeholderImage}
                        style={{
                            ...profile_pic_style,
                            width: Math.min(600, window.innerWidth*0.75),
                            height: Math.min(600, window.innerWidth*0.75),
                        }}
                    />
                </div>
            )}
        </div>
    );
}

function UserList({ userId, userDevices, castellersInfo }) {
    const userIsYou = (user) => parseInt(user) === parseInt(userId);

    return (
        <div
            style={{
                flex: 1,
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                overflowX: 'auto',
                gap: 5,
            }}
        >
            {
                Object.entries(userDevices).map(([user, devices]) => {
                    const casteller = castellersInfo[user];
                    if (!casteller) return null;
                    return (
                        <div
                            key={user}
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: 5,
                                borderRadius: 10,
                                padding: 10,
                                backgroundColor: userIsYou ? '#ccc' : '#eee',
                            }}
                        >
                            <div className="user-profile-pic">
                                <ProfilePic
                                    user={user}
                                    width={50}
                                    height={50}
                                />
                            </div>
                            <div className="user-name">
                                {getCastellerDisplayName(casteller)}
                            </div>
                            <div
                                style={{
                                    fontSize: 12,
                                }}
                            >
                                {devices} 💻
                            </div>
                        </div>
                    )
                })
            }
        </div>
    )
}

export default UserList;
